module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBoldItalic.376e8f19.ttf";